export class BenefitRequestType {
  public static readonly ADD ="Add";
  public static readonly DELETE = "Delete";
}
